import { render, staticRenderFns } from "./statusFilters.vue?vue&type=template&id=bca27ea2&"
import script from "./statusFilters.vue?vue&type=script&lang=ts&"
export * from "./statusFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports